// extracted by mini-css-extract-plugin
export default {"split":"TemplateDialog_split__HRJ6h","splitColumn":"TemplateDialog_splitColumn__-394t"};